import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from '../../components/header/Header';

interface LayoutProps {
    children?: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = () => {
    return (
        <div className="layout">
            <header>
                <Header />
            </header>
            
            <main>
                <Outlet />
            </main>

            <footer>
            </footer>
        </div>
    );
};

export default Layout;